import React, { ReactNode } from "react";
import { classes } from "components/Utility";
import CMSHelpIcon from "components/CMS/CMSHelpIcon";

interface Props {
  children: string,
  className?: string,
  htmlFor?: string,
  controlType?: "div" | "span" | "label",
  helpTopicId?: string,
};

const labelClass = "pnx-html-label";

const PNXLabel = ({
  children,
  className,
  htmlFor,
  controlType = "div",
  helpTopicId,
}: Props) => {
  let props = {
    className: classes(labelClass, className),
    dangerouslySetInnerHTML: { __html: children },
  } as any; // we goin crazy here

  if (htmlFor) props.htmlFor = htmlFor;

  let labelControl: ReactNode;
  switch (controlType) {
    case "span":
      labelControl = <span {...props} />;
      break;
    case "label":
      labelControl = <label {...props} />;
      break;
    case "div":
    default:
      labelControl = <div {...props} />;
      break;
  }

  let labelHelpButton = helpTopicId && <CMSHelpIcon topicId={helpTopicId} />;

  return <div className="pnx-label-wrapper">{labelControl}{labelHelpButton}</div>
};

export default PNXLabel;
